export const getRangeColor = (value: number) => {
  if (value >= 60) return 'success';
  if (value <= 30) return 'danger';
  return 'warning';
};
